/**
 * <AccountSignOut> — le pied de « Mon compte » : « Se déconnecter » et la version de l'app
 * (molecule).
 *
 * Le pied de « Mon compte » de l'élève (`<StudentAccountPage>`) : l'ancien `LogoutButton` (« Changer de
 * compte », qui déconnecte) et sa ligne « Version … ». Le geste et le mot sont ceux du pied de la feuille
 * « moi » (Wajih, 16/10), qui porte aussi la version chez le masteur (`<ProfileSwitcherSheet version>`).
 */
import React from "react"

import { Button } from "../../atoms/Buttons/Button"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"

export type AccountSignOutProps = {
    onSignOut: () => void
    /** La sortie est en cours : le bouton tourne et ne répond plus. */
    signingOut?: boolean
    /** « 3.9.2 ». Absent : pas de ligne. */
    version?: string
    testID?: string
}

export function AccountSignOut(props: AccountSignOutProps) {
    const { onSignOut, signingOut = false, version, testID } = props

    return (
        <Stack gap="2" align="center" testID={testID}>
            <Button
                label="Se déconnecter"
                iconName="sign-out-alt"
                variant="outline"
                loading={signingOut}
                onPress={onSignOut}
            />
            {version != null && (
                <Text size="text-sm" color="text-muted" center>
                    {`Version ${version}`}
                </Text>
            )}
        </Stack>
    )
}
